/**
 * contains the abi and contract address
*/

class EffectsContract {
    constructor() {
        this.abi = [
	    {
		"inputs": [
		    {
			"internalType": "address",
				"name": "guildsAddress",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "effectHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "effectType",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "tag",
				"type": "bytes32"
			}
		],
		"name": "EffectTagged",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "effectHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "effectType",
				"type": "bytes32"
			},
			{
				"internalType": "string",
				"name": "title",
				"type": "string"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "newEffect",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "effectHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "effectType",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "title",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "NewEffect",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "effectHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "effectType",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "tag",
				"type": "bytes32"
			}
		],
		"name": "tagEffect",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
        ];

        
        this.contractAddress = '0x133F927E9d1b94e6f274eAa4eEE21d29c65782B4';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default EffectsContract;
